import * as React from "react";
import type { SVGProps } from "react";
const CodePanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M6 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm1.416 8.376a.75.75 0 1 0-.832 1.248L8.648 15l-2.064 1.376a.75.75 0 1 0 .832 1.248l3-2a.75.75 0 0 0 0-1.248z" clipRule="evenodd" /></svg>;
export default CodePanelIcon;